/**
 * Return default country for site
 * @return {string}
 */
function getDefaultCountryCode () {

	return 'US';

}

export default getDefaultCountryCode;
